const defaultFields = [
  // {
  //   field: 'commands',
  //   title: ' ',
  //   cell: 'commands',
  //   headerCell: 'commandsHeader',
  //   sortable: false,
  //   hidden: false,
  //   locked: true,
  //   width: 40,
  // },
  // {
  //   field: 'selectcommands',
  //   title: ' ',
  //   cell: 'selectcommands',
  //   headerCell: 'selectCommandsHeader',
  //   sortable: true,
  //   hidden: false,
  //   locked: true,
  //   width: 30,
  // },
  {
    key: 'Id',
    field: 'id',
    title: ' Id',
    label: 'Id',
    cell: 'navigation',
    sortable: true,
    hidden: false,
  }, {
    key: 'Name',
    field: 'name',
    title: 'Name',
    label: 'Name',
    sortable: true,
    hidden: false,
  },
  {
    key: 'Subject',
    field: 'subject',
    title: 'Subject',
    label: 'Subject',
    sortable: true,
    hidden: false,
  }, {
    key: 'emailTemplateCategoryName',
    field: 'emailTemplateCategoryName',
    title: 'Template Category',
    label: 'emailTemplateCategoryName',
    sortable: true,
    hidden: true,
  }, {
    key: 'Message Format',
    field: 'msgFormat',
    title: 'Message Format',
    label: 'Message Format',
    sortable: true,
    hidden: false,
  }, {
    key: 'To Recipients',
    field: 'toRecipients',
    title: 'To Recipients',
    label: 'To Recipients',
    sortable: true,
    hidden: false,
  }, {
    key: 'cc Recipients',
    field: 'ccRecipients',
    title: 'cc Recipients',
    label: 'cc Recipients',
    sortable: true,
    hidden: false,
  },
  {
    key: 'bcc Recipients',
    field: 'bccRecipients',
    title: 'bcc Recipients',
    label: 'bcc Recipients',
    sortable: true,
    hidden: false,
  }, {
    key: 'body',
    field: 'body',
    title: 'body',
    label: 'body',
    sortable: true,
    hidden: true,
  }, {
    key: 'Email AccountId',
    field: 'emailAccountId',
    title: 'Email AccountId',
    label: 'Email AccountId',
    sortable: true,
    hidden: false
  }, {
    key: 'Is Admin Only',
    field: 'isAdminOnly',
    title: 'Is Admin Only',
    label: 'Is Admin Only',
    sortable: true,
    hidden: false
  }, {
    key: 'Created By',
    field: 'createdByUserFullName',
    title: 'Created By',
    label: 'Created By',
    sortable: true,
    hidden: true,
  }, {
    key: 'Date Created',
    field: 'dateCreated',
    title: 'Date Created',
    label: 'Date Created',
    sortable: true,
    hidden: true,
  }, {
    key: 'Date Modified',
    field: 'dateModified',
    title: 'Date Modified',
    label: 'Date Modified',
    sortable: true,
    hidden: true,
  }, {
    key: 'Modified By',
    field: 'modifiedByUserFullName',
    title: 'Modified By',
    label: 'Modified By',
    sortable: true,
    hidden: true,
  }, {
    key: '',
    field: 'modifiedByUserId',
    title: 'modifiedByUserId',
    label: 'modifiedByUserId',
    sortable: true,
    hidden: true,
  }, {
    key: 'Active',
    field: 'active',
    title: 'Active',
    label: 'Active',
    sortable: true,
    hidden: true,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
];
export default defaultFields;
